/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Enum for different types of insurance relevant to quoting system.
 */
export var InsuranceType;

(function (InsuranceType) {
  InsuranceType["GOODS_IN_TRANSIT_INSURANCE"] = "goods-in-transit-insurance";
  InsuranceType["BUSINESS_INSURANCE"] = "business-insurance";
  InsuranceType["CONSTRUCTION_INSURANCE"] = "construction-insurance";
})(InsuranceType || (InsuranceType = {}));